<template>
  <el-tab-pane></el-tab-pane>
  <!-- <el-tab-pane> <slot /> </el-tab-pane> -->
</template>

<script>
export default {
  name: 'RtTabPane'
};
</script>



// WEBPACK FOOTER //
// rtTabPane.vue?6ed05663